import React from "react";
import { ShieldMark } from "@/components/BrandLogo";

export const BrandMark = () => (
    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
        <ShieldMark className="w-8 h-8 sm:w-9 sm:h-9" />
        <span className="font-display text-base sm:text-lg font-semibold tracking-tight whitespace-nowrap">
            AuditVanguard
        </span>
    </div>
);
